/**
 * Chrome for the logged-out marketing/public surface: the landing page and the
 * public property listings (app_router.dart:95-98 and :456-476).
 *
 * Carbon's Header with no SideNav — there is nothing to collapse behind a
 * hamburger here, just two links and the theme toggle, so `HeaderNavigation`
 * carries them directly rather than pulling in the SideNav machinery
 * ShellFrame needs for its much longer per-role nav tables.
 */
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { Link, Outlet } from 'react-router-dom';
import {
  Content,
  Header,
  HeaderGlobalBar,
  HeaderMenuItem,
  HeaderName,
  HeaderNavigation,
  SkipToContent,
} from '@carbon/react';
import { ROUTES } from '../routes/paths';
import { ThemeToggle } from '../components/ThemeToggle';

/** Same stable router-Link adapter ShellFrame uses — see its own comment for why it must not be defined inline. */
const RouterAnchor = forwardRef<HTMLAnchorElement, ComponentPropsWithoutRef<typeof Link>>(
  function RouterAnchor(props, ref) {
    return <Link {...props} ref={ref} />;
  },
);

export function PublicLayout(): React.JSX.Element {
  return (
    <div className="public">
      <Header aria-label="Rent Management">
        <SkipToContent />
        <HeaderName as={RouterAnchor} to={ROUTES.landing} prefix="">
          Rent Management
        </HeaderName>
        <HeaderNavigation aria-label="Public navigation">
          <HeaderMenuItem as={RouterAnchor} to={ROUTES.publicProperties}>
            Browse properties
          </HeaderMenuItem>
          <HeaderMenuItem as={RouterAnchor} to={ROUTES.login}>
            Sign in
          </HeaderMenuItem>
        </HeaderNavigation>
        <HeaderGlobalBar>
          <ThemeToggle />
        </HeaderGlobalBar>
      </Header>

      <Content id="main-content">
        <Outlet />
      </Content>
    </div>
  );
}

export default PublicLayout;
